import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {DefaultBtn} from "Ncontracts.Common.UI";
import {imageCdnUrls} from "../common/ImageCdnUrls";
import isEmpty from "../../helpers/isEmpty";

class DeletePrompt extends Component {

    static propTypes = {
        cancelButtonHandler: PropTypes.func,
        deleteButtonHandler: PropTypes.func,
        isActive: PropTypes.bool,
        message: PropTypes.string
    };

    constructor(props) {
        super(props);
    }

    render() {
        const {message} = this.props;

        return (
            <div className={`modal delete-prompt-modal ${this.props.isActive ? 'is-active' : ''}`}>
                <div className="modal-background"/>
                <div className="modal-card modal-content">
                    <section className="modal-card-body">
                        <div className="has-text-centered delete-image">
                            <img src={imageCdnUrls.x_error} width="40" height="40"/>
                        </div>
                        <div className="has-text-centered main-text">
                            Are you sure?
                        </div>
                        <div className="has-text-centered subtext">
                            {isEmpty(message) ? 'All data for this item will be deleted immediately.' : message}
                        </div>
                    </section>
                    <footer className="modal-card-foot">
                        <div className="modal-footer-buttons has-text-centered">
                            <DefaultBtn onClick={this.props.cancelButtonHandler}
                                        className="btn--base btn--smaller cancel-button">Cancel</DefaultBtn>
                            <DefaultBtn onClick={this.props.deleteButtonHandler}
                                        className="btn--smaller btn--destructive-solid">Delete</DefaultBtn>
                        </div>
                    </footer>
                </div>
            </div>);
    }
}

export default DeletePrompt;
